import React from "react";
import { Modal, Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { ApiURL } from "../services/apiConstants";
import { post } from "../services/services";
import { ErrorToast, SuccessToast } from "../widgets/AppToast";

const { TextArea } = Input;

const RequestFormModal_ballast_record = ({
  visible,
  onCancel,
  record_id,
  voyage_ids,
  setModalVisible,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const handleFinish = async (values) => {
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", Number(voyage_ids));
      FORM_DATA.append("ballast", "1");
      FORM_DATA.append("record_id", Number(record_id));
      FORM_DATA.append("description", values?.description);
      const response = await post(
        ApiURL?.ballasting_requests_notification_st,
        FORM_DATA
      );
      if (response?.status === true) {
        SuccessToast(
          "Congratulations!",
          response?.message || "No message returned."
        );
        navigate(`/edit-ballast-record/${btoa(record_id)}`);
      } else {
        console.error("Error:", response?.message || "Something went wrong.");
        ErrorToast("Error", response?.message || "Something went wrong.");
      }
      setModalVisible(false);
    } catch (error) {
      console.error("Error in CREATE_REQUEST_EDIT_VARIFAY:", error);
      ErrorToast(
        "Request Failed",
        "Could not complete the request. Please try again."
      );
    }
    form.resetFields();
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Submit Request"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please enter a description" }]}
        >
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default RequestFormModal_ballast_record;
